
import React from 'react';
import { useLocation } from 'react-router-dom';
import SidebarLink from './SidebarLink';
import { BarChart3, DollarSign, HelpCircle, Settings, User, MessageSquare, BookOpen } from 'lucide-react';

interface AuthorLinksProps {
  isOpen: boolean;
}

const AuthorLinks: React.FC<AuthorLinksProps> = ({ isOpen }) => {
  const location = useLocation();
  
  return (
    <>
      <SidebarLink 
        to="/author/dashboard" 
        icon={<BarChart3 className="h-5 w-5" />} 
        label="Dashboard" 
        isActive={location.pathname === '/author/dashboard'}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/books" 
        icon={<BookOpen className="h-5 w-5" />} 
        label="My Books" 
        isActive={location.pathname.startsWith('/author/books')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/guide" 
        icon={<BookOpen className="h-5 w-5" />} 
        label="Author Guide" 
        isActive={location.pathname === '/author/guide'}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/royalties" 
        icon={<BarChart3 className="h-5 w-5" />} 
        label="Royalty Reports" 
        isActive={location.pathname.startsWith('/author/royalties')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/payments" 
        icon={<DollarSign className="h-5 w-5" />} 
        label="Payments" 
        isActive={location.pathname.startsWith('/author/payments')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/help" 
        icon={<HelpCircle className="h-5 w-5" />} 
        label="Help Center" 
        isActive={location.pathname.startsWith('/author/help')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/tickets" 
        icon={<MessageSquare className="h-5 w-5" />} 
        label="My Tickets" 
        isActive={location.pathname.startsWith('/author/tickets')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/payment-preferences" 
        icon={<Settings className="h-5 w-5" />} 
        label="Payment Preferences" 
        isActive={location.pathname.startsWith('/author/payment-preferences')}
        isOpen={isOpen}
      />
      <SidebarLink 
        to="/author/account" 
        icon={<User className="h-5 w-5" />} 
        label="Account Settings" 
        isActive={location.pathname.startsWith('/author/account')}
        isOpen={isOpen}
      />
    </>
  );
};

export default AuthorLinks;
